import { render } from "./verifyPhone.vue?vue&type=template&id=65bbbedd&ts=true"
import script from "./verifyPhone.vue?vue&type=script&lang=ts"
export * from "./verifyPhone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__